
import { coleccionesDTO } from "../../../models/Colecciones.model"
import RecuadroIndividual from "./recuadro_indivual"

export default function IniciaRow(props: propsIniciaRow){
    const asignaTamanio = () => { 
       return  ( 500  / ( Object.getOwnPropertyNames(props.colec).length - 1))
    }
    const getHijos = (padre:any ) =>  props.data?.filter( (col) => padre === col.padre);
    return(  
        <>
            <div className="col-12 col-md-6 col-lg-3 px-0 tamano-div">
                {  
                    (props.colec)?.map( (cole) => <RecuadroIndividual key={cole.id} titulo={cole.titulo} asignaTamanio={asignaTamanio()} id={cole.id} hijos={getHijos(cole.id)} columna={cole.columna}/> )
                }
            </div>
        </>
        )
}

interface propsIniciaRow{
    element: number,
    titulo: string,
    id: number,
    colec?:Array<coleccionesDTO>,
    data?:Array<coleccionesDTO>,
}